// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__rxzVv","menuItemStyle":"Menu_menuItemStyle__m6zdM","SubmenuItemStyle":"Menu_SubmenuItemStyle__lRKal"};